import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import marked from 'marked';

import AnimateIn from './AnimateIn';

const Markdown = ({ component, className }) => {
  const { html, original } = component.markdown
  if (!html && !original) return null

  let markedHtml = marked(html);

  return (
    <>
      <AnimateIn
        className={classNames('component', 'markdown', 'text', 'g-row', className)}
      >
        <div dangerouslySetInnerHTML={{ __html: markedHtml }} />
      </AnimateIn>
    </>
  );
};

export default Markdown;
